import React from 'react'
import { useState , useEffect } from 'react'
import Profile from './Profile';
import Wishlist from '../Wishlist/Wishlist';
import Addresses from './Addresses';
import OrderTable from '../Orders/OrderTable';


const Index = () => {
    const [count , setCount]=useState(0);
    const [user , setUser]=useState("")
    
    useEffect(() => {
      const userData = JSON.parse(localStorage.getItem('user'));
      console.log(userData)
      setUser(userData);
    }, []);



    const dummyData = [
      {
        "_id": "6540dc77ec2d7548f5f2170a",
        "shippingInfo": {
          "address": "123 Main St",
          "city": "New York",
          "state": "NY",
          "country": "USA",
          "pincode": 12345,
          "phoneNo": 1234567890
        },
        "paymentInfo": {
          "id": "paymentId123",
          "status": "Paid"
        },
        "orderItems": [
          {
            "name": "Product A",
            "price": 10,
            "quantity": 2,
            "image": "productA.jpg",
            "product": "70726f647563744964313233",
            "_id": "6540dc77ec2d7548f5f2170b"
          },
          {
            "name": "Product B",
            "price": 15,
            "quantity": 1,
            "image": "productB.jpg",
            "product": "70726f647563744964343536",
            "_id": "6540dc77ec2d7548f5f2170c"
          }
        ],
        "user": {
          "_id": "6540673faf632959bfb00341",
          "name": "Shubham Chaudhari",
          "email": "chaudhary@gmail.com"
        },
        "paidAt": "2023-10-31T12:00:00.000Z",
        "totalPrice": 35,
        "orderStatus": "Processing",
        "createdAt": "2023-10-31T12:00:00.000Z",
        "__v": 0
      },
      // Add more dummy data if needed...
    ];
  

    const item = user.user  
    const component = [<Profile/>,<Wishlist/>,<Addresses/>,<OrderTable orders={dummyData}/>]
    const itemstyle = "text-xl uppercase text-center py-2 border-b-2 hover:bg-gray-300"
  return (
    <div className=' max-w-6xl mx-auto flex gap-2 min-h-screen py-2'>
        <div className='left w-[25%] gap-4 flex flex-col' >
            <div className=' border-2 flex  justify-left px-5 py-2 gap-5  items-center w-full '>
                <span><img className=' h-12 w-12 rounded-full object-cover' src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRV9whehM4lq6slYvQv68ECz49vHnRUxkicrGJMJqsbdR-CdkjZsk-1ZN2KGgLDG44LAnM&usqp=CAU" alt="" /></span>
                <span>

                {item?.name}
                </span>
                </div>
            <div className=' border-2  cursor-pointer'>
                <div onClick={()=>setCount(0)} className={itemstyle}>Profile</div>
                <div onClick={()=>setCount(3)}  className={itemstyle}>order</div>
                <div className={itemstyle}>track order</div>
                <div onClick={()=>setCount(1)} className={itemstyle}>Wishlist</div>
                <div onClick={()=>setCount(2)} className={itemstyle}>Addresses</div>
                <div className={itemstyle} >Logout</div>
            </div>
        </div>
        <div className='right w-[70%]  border-2 flex justify-center overflow-hidden  h-fit  '>
            {component[count]}
        </div>
    </div>
  )
}

export default Index